<template>
    <div>
        <rooster-header title="Projects"></rooster-header>

        <div class="crud-container">
            <div v-if="projects.length">
                <h4>Existing Projects</h4>
                <table class="table table-striped mt-3">
                    <thead>
                    <tr>
                        <th>Project</th>
                        <th class="d-none d-sm-table-cell">Rate</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="project in projects">
                        <td>{{project.name}} <span v-if="project.client">[{{ project.client.name }}]</span></td>
                        <td class="d-none d-sm-table-cell">{{project.rate}}</td>
                        <td class="text-right">
                            <a href="#" @click.prevent="editProject(project)" class="text-info"><i class="fas fa-edit"></i></a>
                            <a href="#" @click.prevent="deleteProject(project)" class="text-danger"><i class="fas fa-trash"></i></a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div class="create-form-cont">
                <project-form @created="onCreated" :clients="clients">
                    <p v-if="projects.length==0" class="alert alert-info">No projects yet. Here, you can create one easily:</p>
                </project-form>
            </div>
        </div>

        <b-modal ref="editModal" title="Edit project"
                 @ok.prevent="sendSubmitSignalToEditForm"
        >
            <project-form @updated="onUpdated" :project="editedProject" :clients="clients" ref="editForm"></project-form>
        </b-modal>
    </div>
</template>

<script>
    Vue.component('rooster-header', require('../Header').default);
    Vue.component('project-form', require('../ProjectForm').default);

    export default {
        name: "Projects",

        props: [
            "homeUrl",
            "user",
            "clients",
        ],

        data: function() {
            return {
                projects: [],
                newProject: [],
                editedProject: false,
            }
        },

        mounted() {
            this.fetchProjects();
            //console.log(this.clients);
        },

        methods: {
            fetchProjects() {
                const that = this;

                window.axios("api/project", {user_id: 'current'})
                    .then(function(resp){
                        that.projects = resp.data;
                    }).catch(function (error) {
                        if (error.response && error.response.status == 401) {
                            that.$emit("forgot-user");
                        } else {
                            console.log("Got some unexpected error: ", error);
                        }
                    });
            },

            onCreated(e) {
                this.fetchProjects();
            },

            onUpdated(p) {
                this.editedProject = false;
                this.$refs.editModal.hide();
                this.fetchProjects();
            },

            deleteProject(p) {
                const that = this;
                if (!confirm("Are you sure you want to delete this project?")) {
                    return ;
                }

                window.axios.delete("api/project/" + p.id)
                    .then(function(resp){
                        that.fetchProjects();
                    })
            },

            editProject(p) {
                this.$refs.editModal.show();
                this.editedProject = p;

                console.log(this.editedProject);
            },

            sendSubmitSignalToEditForm() {
                this.$refs.editForm.sendSubmitSignal()
            }
        }
    }
</script>

<style scoped>
@media (min-width: 1200px) {
    .crud-container {
        display: flex;
        gap: 2rem;
        justify-content: space-between;
    }
    .crud-container > * {
        flex-grow: 2;
    }
    .create-form-cont {
        flex-basis: 13rem;
    }
}
</style>
